document.addEventListener("DOMContentLoaded", function () {
  let header = document.querySelector(".header");
  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    let scrollPos = window.scrollY;

      if (scrollPos > 10) {
        header.classList.add("scroll");
      } else {
        header.classList.remove("scroll");
      }


      if (scrollPos > 500) {
        header.classList.add("disappeared");
      }

      if (scrollPos < lastScrollTop) {
        header.classList.remove("disappeared");
      }

    lastScrollTop = scrollPos;
  });
});
